import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import ErrorStyles from './Error.css';

class Error404 extends Component {
  render() {

      if(this.props.location && typeof this.props.location.pathname === 'string' && this.props.location.pathname.toLowerCase() === '/faq') {
        return <Redirect to={'/'}/>
      }
        return (
            <div className="error-container">
                <div className="error">
                    <h1>404</h1>
                </div>
            </div>
        );
    }

}

export default Error404;



// WEBPACK FOOTER //
// ./src/components/Error404.js